<script lang="ts" setup>
import type { SubjectCode } from '~/models/Subject'
import type { GradeCode } from '~/models/Grade'
import { useRouter }  from '#imports'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import Button from '~/components/ui/Button.vue'

const props = defineProps<{
  subjectCode: SubjectCode
  gradeCode: GradeCode
  contentId: number
}>()

const { t } = useI18n()
const router = useRouter()

const overrideRoute = computed(() => ({
  name: 'teacher_subject',
  params: {
    subject: props.subjectCode.toLowerCase(),
    grade: props.gradeCode,
    contentId: props.contentId
  }
}))
</script>

<template>
  <Button
    v-if="overrideRoute"
    :to="overrideRoute"
    color="teacher"
    size="lg"
  >
    {{ t('filters.forTeacher') }}
  </Button>
</template>
